import { Component } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { merge, Observable } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DumbPendingLetter } from './DTOs/dumb-pending-letter';
import { PendingLettersService } from './pending-letters.service';
import { PendingLettersDtRetInfo } from './DTOs/pending-letters-dt-ret-info';
import { GetPendingLettersListRequest } from './DTOs/get-pending-letters-list-request';
import { PendingLetterInfo } from './DTOs/pending-letter-info';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { UpdateLetterRequest } from './DTOs/update-letter-request';
import { EditLetterContentModalComponent } from './Modals/edit-letter-content-modal.component';

@Component({
  selector: 'app-pending-letter-details',
    templateUrl: './pending-letter-details.component.html',
    providers: [UIBlockingService, NgbDropdown],

})
export class PendingLetterDetailsComponent {
    constructor(private pendingLettersService: PendingLettersService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router) { }

    letter: PendingLetterInfo;
    lettersLeft = 0;

    openEditModal() {
        const modalRef = this.modalService.open(EditLetterContentModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.letter = this.letter;
        modalRef.result.then(response => {
            this.getPendingLetterInfo();
        })
            .catch(err => {
            });
    }

    ngOnInit() {
        this.letter = new PendingLetterInfo();
        this.getPendingLetterInfo();
    }

    getPendingLetterInfo() {
        this.blockUI.start();
        this.pendingLettersService.getPendingLetterInfo(parseInt(this.route.snapshot.paramMap.get("id"))).subscribe({
            next: (data) => {
                this.letter = data;
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.lettersLeft = 10 - this.letter.lettersUsed;
            }
        });
    }

    PublishArticle(status: number) {
        const req = new VerifyRejectRequest(this.letter.letterId.toString(), this.letter.approverNotes);
        this.pendingLettersService.changeLetterStatus(req, status).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.blockUI.stop();
                this.notificationService.error(err.error.message);
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.router.navigate(['/admin-portal/chamber/pending-letters/']);
            }
        });
    }
}
